import {
  addCompletedQuest,
  incrementLocalGamesPlayed,
  syncLocalGamesPlayed,
  updatePlayerRewards,
} from '../../redux/actions';
import {resendPendingLocalMatchResults} from './saveLocalMatchResults';

/**
 * Последствия сохраненных итогов локальной партии для профиля в сторе:
 * сервер зачел матч (счетчики, задание, награда), а /auth/me после матча не
 * перезапрашивается.
 *
 * Работает через стор, а не через состояние модалки итогов: ответ может
 * прийти и после того, как игрок вышел из партии (сохранение повторяется при
 * сбоях сети), и при следующем входе (досылка несохраненных итогов).
 *
 * Все шаги, кроме прибавки счетчика, безопасно повторять: счетчик
 * выставляется по значению с сервера, задание гасится один раз, метка новых
 * предметов — флаг.
 *
 * @param {Object} data - ответ POST /api/users/me/local-matches
 * @param {Function} dispatch
 * @param {Object} [options]
 * @param {boolean} [options.isMatchCountedNow] - матч зачтен после того, как
 *   профиль в сторе был загружен: счетчик нужно прибавить. Так у модалки
 *   итогов; у досылки после входа неизвестно, учтен ли матч в свежем
 *   профиле, — там счетчик только сверяется со значением сервера
 * @returns {Object|null} награда за задание — показать ее модалкой, если есть где
 */
export const applyLocalMatchSaveResult = (data, dispatch, {isMatchCountedNow = false} = {}) => {
  // Счетчик локальных партий: по нему главное меню решает, звать ли игрока
  // дальше по воронке (см. utils/menuPromo)
  if (isMatchCountedNow) {
    dispatch(incrementLocalGamesPlayed());
  }
  // Значение сервера — поверх прибавки: если оно уже учитывает матч, ничего
  // не изменится; если сервер ушел вперед (матч зачла прошлая попытка) —
  // стор его догонит
  if (Number.isInteger(data?.localGamesPlayed)) {
    dispatch(syncLocalGamesPlayed(data.localGamesPlayed));
  }
  // Задания гасим по списку с сервера, а не по типу награды — тот же
  // порядок, что у сетевого матча (см. getOwnMatchResultProfileActions)
  (data?.completedQuestIds || []).forEach((questId) => dispatch(addCompletedQuest(questId)));

  const questReward = data?.questReward || null;
  if (questReward) {
    // Награда уже в профиле на сервере: метку «Новое» в коллекции зажигаем
    // сразу, не дожидаясь наградной модалки, — ее может и не быть
    dispatch(updatePlayerRewards(0, undefined, true));
  }
  return questReward;
};

/**
 * Дослать после входа итоги локальных партий, не дошедшие до сервера в
 * прошлый раз, и довести профиль в сторе до того, что получилось на сервере.
 * Наградной модалки здесь нет — партия давно кончилась; награда видна в
 * коллекции по метке «Новое».
 *
 * @param {string} userId
 * @param {Function} dispatch
 * @param {Object} [saveOptions] - как у saveLocalMatchResults (тесты)
 */
export const resendLocalMatchResultsOnAuth = (userId, dispatch, saveOptions = {}) => (
  resendPendingLocalMatchResults(userId, {
    ...saveOptions,
    onSaved: (data) => {
      applyLocalMatchSaveResult(data, dispatch);
    },
  })
);
